// src/cert/iso9001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css'; // आता फाइल आहे!

const ISO9001 = () => {
  return (
    <div className="cert-page">
      {/* Header */}
      <div className="cert-header">
        <h1>ISO 9001 प्रमाणन</h1>
        <p>गुणवत्ता व्यवस्थापन प्रणाली (QMS)</p>
      </div>

      {/* Content */}
      <div className="cert-content">
        <section>
          <h2>...ISO 9001...</h2>
          <p>
            The ISO 9001 standard requirements are generic and are intended to be applicable to any type of organization, regardless of its type or size, or the products and services it provides. World first ISO standards which is most acceptable in market globally.

ISO 9001:2015 Quality Management System (QMS) is internationally recognized as the world’s leading quality management standard and has been implemented by over one million organizations in over 170 countries globally. ISO 9001 implemented, to its full potential, becomes an invaluable asset to your organization.

The purpose of the standard is to assist companies in meeting statutory and regulatory requirements relating to their product while achieving excellence in their customer service and The standard can be used throughout an organization to improve the performance or within a particular site, plant or department.

ISO 9001 contains eight key principles of quality management which is not auditable but do form the fundamental characteristics of quality management.

          </p>
        </section>

        <section>
          <h2>प्रमुख फायदे</h2>
          <ul>
            <li>ग्राहक समाधान वाढते</li>
            <li>प्रक्रियांचे चांगले नियंत्रण</li>
            <li>जागतिक मान्यता आणि बाजारपेठ प्रवेश</li>
            <li>कचरा आणि खर्च कमी होतात</li>
          </ul>
        </section>

        {/* Apply Form */}
        <section className="apply-section">
          <h2>ISO 9001 साठी अर्ज करा</h2>
          <ApplyForm certification="ISO 9001" />
        </section>
      </div>
    </div>
  );
};

export default ISO9001;